// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_fp-0";
export var actionModalContentContainer = "_fp-1";
export var createTagButton = "_fp-2";
export var footerContainer = "_fp-7";
export var fullWidthDivider = "_fp-3";
export var hasCreateTagButton = "_fp-4";
export var noCreateTagButton = "_fp-5";
export var tagsContainer = "_fp-6";
export var tagsModalContentContainer = "_fp-8";